<template>
  <div>
    <div v-for="(page, index) in pageGroupedElements" :key="'page-' + index" class="position-relative dinA4">
      <img :src="require('@/assets/peninsular-header.png')" class="mb-0 page__header" />
      <div class="page__container">
        <div v-for="(element, elementIndex) in page" :key="'element-' + elementIndex"
          style="position: relative; z-index: 100;">
          <div v-if="element.type === 'table'" class="d-flex justify-center" style="width: 100% !important;">
            <PdfProductTable type="peninsular" :tableData="productTableList[element.id]" :tableId="element.id"
              :image="element.imageUrl" />
          </div>
          <div v-else class="d-flex justify-center mb-10">
            <div class="small-letter-section" style="width: 100% !important;">
              <p class="small-letter-font small-letter-font--bold mb-0">
                {{ element.title }}
              </p>
              <ul class="small-letter-font">
                <li v-for="(listElement, listIndex) in element.list" :key="'listElement-' + listIndex"
                  v-html="listElement" />
              </ul>
            </div>
          </div>
        </div>
      </div>

      <Footer logo :page="previousPages + 1 + index" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_PDF_PRODUCT_TABLE_LIST } from '@/store/modules/offer/getters'
import PdfProductTable from '@/containers/offer-form/sign-off/pdf-venta-directa-2026/PdfProductTable'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2026/Footer'

export default {
  name: 'PeninsularTables',
  components: {
    PdfProductTable,
    Footer,
  },
  data() {
    return {
      elements: [
        {
          type: 'table',
          imageUrl: require('@/assets/ctt24-icon.png'),
          id: '24H',
        },
        {
          type: 'text',
          title: 'Características de los servicios CTT 24h y CTT e24h:',
          list: [
            '- Peso máximo por bulto: 30 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. Este servicio admite exceso de peso y exceso de medida (consultar página de este documento: Otras Consideraciones).',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- Los envíos que dispongan de email se beneficiarán GRATIS de la notificación de <u>Entrega Prevista,</u> <u>Entrega Hoy y Entregado</u>, además de la <u>Gestión Proactiva de Localización</u> en caso de ausencia del destinatario o dirección incorrecta.',
            '- Todos los envíos llevan incluida la entrega en más de 20.000 puntos Collectt Express (España y Portugal) <u>sin coste adicional.</u>',
          ],
        },
        {
          type: 'table',
          imageUrl: require('@/assets/entpremium-icon.png'),
          id: 'C14E',
        },
        {
          type: 'text',
          title: 'Características del servicio CTT Premium Empresas 14h:',
          list: [
            '- Envíos con origen y destino empresas con horario comercial publicado.',
            '- Peso máximo por bulto: 30 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. Este servicio admite exceso de peso y exceso de medida (consultar página de este documento: Otras Consideraciones).',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- Cobertura: Capitales de provincia o ciudades de más de 100.000 habitantes y poblaciones a menos de 15 Km de nuestra delegación de destino <u>sin coste adicional</u>. Resto de poblaciones 24h',
            '- Los envíos que dispongan de email se beneficiarán GRATIS de la notificación de <u>Entrega Prevista,</u> <u>Entrega Hoy y Entregado</u>, además de la <u>Gestión Proactiva de Localización</u> en caso de ausencia del destinatario o dirección incorrecta.',
            '- Todos los envíos llevan incluida la entrega en más de 20.000 puntos Collectt Express (España y Portugal) <u>sin coste adicional.</u>',
          ],
        },
        {
          type: 'table',
          imageUrl: require('@/assets/ctt1330-icon.png'),
          id: '13h',
        },
        {
          type: 'text',
          title: 'Características del servicio CTT 14h:',
          list: [
            '- Peso máximo por bulto: 30 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. Este servicio admite exceso de peso y exceso de medida (consultar página de este documento: Otras Consideraciones)',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- Los envíos que dispongan de email se beneficiarán GRATIS de la notificación de <u>Entrega Prevista,</u> <u>Entrega Hoy y Entregado</u>, además de la <u>Gestión Proactiva de Localización</u> en caso de ausencia del destinatario o dirección incorrecta.',
            '- Todos los envíos llevan incluida la entrega en más de 20.000 puntos Collectt Express (España y Portugal) <u>sin coste adicional.</u>',
          ],
        },
        {
          type: 'table',
          imageUrl: require('@/assets/ctt10-icon.png'),
          id: '10h',
        },
        {
          type: 'text',
          title: 'Características del servicio CTT 10h:',
          list: [
            '- Peso máximo por bulto: 30 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm. No admite exceso de peso y de medidas.',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- Cobertura: Capitales de provincia o ciudades de más de 100.000 habitantes y poblaciones a menos de 15 km de nuestra delegación de destino <u>sin coste adicional.</u> El resto de las poblaciones, llevarán un suplemento por km adicional a partir de 15 km de nuestra delegación de destino más próxima (exentos los primeros 15 km de ida y los primeros 15 km de vuelta) y se incrementará en 1 minuto el compromiso de entrega, por cada km adicional desde esos 15 km de distancia, tanto para la ida como para la vuelta (consultar, en la www.cttexpress.com/suplementos, poblaciones con suplemento por kilometraje).',
            '- Los envíos que dispongan de email se beneficiarán GRATIS de la notificación de <u>Entrega Prevista,</u> <u>Entrega Hoy y Entregado</u>, además de la <u>Gestión Proactiva de Localización</u> en caso de ausencia del destinatario o dirección incorrecta.',
            '- Todos los envíos llevan incluida la entrega en más de 20.000 puntos Collectt Express (España y Portugal) <u>sin coste adicional.</u>',
          ],
        },
        {
          type: 'table',
          imageUrl: require('@/assets/ctt48-icon.png'),
          id: '48h',
        },
        {
          type: 'text',
          title: 'Características de los servicios CTT 48h y CTT e48h:',
          list: [
            '- Peso máximo por bulto: 30 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm con ninguna superior a 150 cm.',
            '- Cubicaje: Conversión volumétrica 167kg/m3',
            '- Este servicio admite exceso de peso y exceso de medida (consultar página de este documento: Otras Consideraciones).',
            '- Los envíos que dispongan de email se beneficiarán GRATIS de la notificación de <u>Entrega Prevista,</u> <u>Entrega Hoy y Entregado</u>, además de la <u>Gestión Proactiva de Localización</u> en caso de ausencia del destinatario o dirección incorrecta.',
            '- Todos los envíos llevan incluida la entrega en más de 20.000 puntos Collectt Express (España y Portugal) <u>sin coste adicional.</u>',
          ],
        },
      ],
      previousPages: 0
    }
  },
  computed: {
    ...mapGetters('offer', [GET_PDF_PRODUCT_TABLE_LIST]),
    productTableList() {
      return this[GET_PDF_PRODUCT_TABLE_LIST]
    },
    pageGroupedElements() {
      let pages = []
      let pageGroup = []
      let singleRow = false
      let doubleRow = false
      let rowElementCounter = 0
      
      // Crear una copia local para no modificar el estado original
      const localProductTableList = {...this.productTableList}

      for (let i = 0; i < this.elements.length; i++) {
        let actualElement = this.elements[i]
        if (actualElement.type !== 'text') {

          // Usar la versión local con datos precargados del método created
          const numberOfRows = Object.keys(localProductTableList[actualElement.id]?.kgRows || {}).length


          if (numberOfRows > 15) {
            singleRow = true
          } else if (numberOfRows > 7) {
            doubleRow = true
          }
        }
        if (singleRow) {
          if (rowElementCounter !== 0) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
            doubleRow = false
          }
          pageGroup.push(actualElement)
          pages.push(pageGroup)
          pageGroup = []
          singleRow = false
        } else if (doubleRow) {
          pageGroup.push(actualElement)
          rowElementCounter++
          if (rowElementCounter % 2 === 0 || rowElementCounter === this.elements.length) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
            doubleRow = false
          }
        } else {
          pageGroup.push(actualElement)
          rowElementCounter++
          if (
            (rowElementCounter === 3 && actualElement.type !== 'table') ||
            (rowElementCounter === 4 && actualElement.type === 'text') ||
            rowElementCounter === this.elements.length
          ) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
          }
        }
      }
      if (pageGroup.length) {
        pages.push(pageGroup)
      }
      return pages
    },
  },
  created() {
    // Inicializar C14E si no existe
    if (this.productTableList && this.productTableList["24H"] && !this.productTableList["C14E"]) {
      const product24h = this.productTableList["24H"]
      const premium = { ...product24h }
      this.$store.commit('offer/updateProductTableList', { key: "C14E", value: premium })
    }
    this.$emit('updateTotalPages', { PeninsularTables: this.pageGroupedElements.length })
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('PeninsularTables')
  },
}
</script>
